import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LinkCellRenderer(props) {
    const navigate = useNavigate();
    const v = props.value;

    // בטיחות: אם זה לא האובייקט המצופה – החזר ערך כ-string
    if (!v || typeof v !== 'object' || !v._id || !v.moduleType) {
        return <>{String(v)}</>;
    }

    const url = `/crm/${v.moduleType}/records/${v._id}`;

    const handleClick = e => {
        e.stopPropagation();          // שלא יפעיל onRowClicked
        e.preventDefault();    // מונע את rowClicked
        navigate(url);
    };
    
    return (
        <span
            className="ag-link"
            onClick={handleClick}
            title={url}
        >
            {v.crmName || v._id}
        </span>
    );
}